import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { IconButton } from '@mui/material';
import React, { useState } from 'react';
import ServiceFeeDialog from './FeeInfoDialog';
import css from './FeeIcon.module.css';

export const FeeIcon = ({ type, commissionPercentage }) => {
  const [isDialogOpen, setDialogOpen] = useState(false);

  const handleDialogClose = e => {
    e.preventDefault();
    e.stopPropagation();
    setDialogOpen(false);
  };

  return (
    <>
      <IconButton
        onClick={() => setDialogOpen(true)}
        size="small"
        className={css.helpIcon}
        sx={{ width: '16px', height: '16px' }}
      >
        <HelpOutlineIcon sx={{ fontSize: '16px' }} />
      </IconButton>
      <ServiceFeeDialog
        isOpen={isDialogOpen}
        onClose={handleDialogClose}
        type={type}
        commissionPercentage={commissionPercentage}
      />
    </>
  );
};
